import { clone } from 'ramda';

import {
    GET_APPLICATION_SETTINGS_DATA,
    GET_APPLICATION_SETTINGS_DATA_SUCCESS,
    FETCH_LANGUAGE_LIST,
    FETCH_LANGUAGE_LIST_SUCCESS,
    FETCH_LANGUAGE_LIST_ERROR,
    FETCH_USERS_ACCESS,
    FETCH_USERS_ACCESS_SUCCESS,
    FETCH_USERS_ACCESS_ERROR,
    DELETE_ADDON_SUCCESS,
    LOAD_ARTICLES_PICKER_SCRIPT_SUCCESS,
    ADD_ON_OAUTH_AUTHORIZATION_CODE_URL_SUCCESS,
    OPEN_ADDON_DETAIL_DRAWER,
    CLOSE_ADDON_DETAIL_DRAWER,
} from 'Console/data/applicationDetail/settings/SettingsConstants';
import { INITIALIZE_CONTENT_LANGUAGE_SUCCESS } from 'Console/data/app/constants';

import { RESET_APPLICATION_DETAIL } from '../constants';

import {
    UPDATE_APPLICATION_ACCESS_REQUEST,
    UPDATE_APPLICATION_ACCESS_FAIL,
    UPDATE_APPLICATION_ACCESS_SUCCESS,
    UPDATE_APPLICATION_ACCESS_IDLE,
    REQUEST_STATUS,
    FETCH_AVAILABLE_LIST_ADDONS_REQUEST,
    FETCH_AVAILABLE_LIST_ADDONS_FAIL,
    FETCH_AVAILABLE_LIST_ADDONS_SUCCESS,
    FETCH_AVAILABLE_LIST_ADDONS_IDLE,
    FETCH_INSTALLED_LIST_ADDONS_REQUEST,
    FETCH_INSTALLED_LIST_ADDONS_FAIL,
    FETCH_INSTALLED_LIST_ADDONS_SUCCESS,
    FETCH_INSTALLED_LIST_ADDONS_IDLE,
    UPDATE_APPLICATION_IDENTITY_IDLE,
    UPDATE_APPLICATION_IDENTITY_FAIL,
    UPDATE_APPLICATION_IDENTITY_SUCCESS,
    UPDATE_APPLICATION_IDENTITY_REQUEST,
    UPDATE_APPLICATION_EXTENSION_URLS_FAIL,
    SettingsState,
    SettingsActionTypes,
    UPDATE_APPLICATION_EXTENSION_URLS_SUCCESS,
    UPDATE_APPLICATION_EXTENSION_URLS_REQUEST,
    UPDATE_APPLICATION_THEME_IDLE,
    UPDATE_APPLICATION_THEME_FAIL,
    UPDATE_APPLICATION_THEME_SUCCESS,
    UPDATE_APPLICATION_THEME_REQUEST,
    ROLLOUT_POLICIES_BY_MY_ORGANIZATIONS_ERROR,
    ROLLOUT_POLICIES_BY_MY_ORGANIZATIONS_REQUEST,
    ROLLOUT_POLICIES_BY_MY_ORGANIZATIONS_SUCCESS,
    ROLLOUT_POLICIES_BY_SPACE_ID_REQUEST,
    ROLLOUT_POLICIES_BY_SPACE_ID_ERROR,
    ROLLOUT_POLICIES_BY_SPACE_ID_SUCCESS,
    UPDATE_APPLICATION_TRUSTED_DOMAINS_REQUEST,
    UPDATE_APPLICATION_TRUSTED_DOMAINS_SUCCESS,
    UPDATE_APPLICATION_TRUSTED_DOMAINS_FAIL,
} from './types';

const initialState = {
    hasError: false,
    isLoading: false,
    updateStatus: REQUEST_STATUS.IDLE,
    isContentLanguageInitialized: false,
    data: {},
    languageList: {
        hasError: false,
        isLoading: true,
        data: [],
    },
    usersAccess: {
        isLoading: false,
        hasError: false,
        data: [],
    },
    addonsAvailable: {
        fetchStatus: REQUEST_STATUS.IDLE,
        reason: null,
        data: [],
    },
    addonsInstalled: {
        fetchStatus: REQUEST_STATUS.IDLE,
        reason: null,
        data: [],
    },
    addons: {
        selected: null,
    },
    addonsScripts: {},
    rolloutPolicies: {
        availableRolloutPolicies: {
            fetchStatus: REQUEST_STATUS.IDLE,
            reason: null,
            data: [],
        },
        rolloutPoliciesBySpace: {
            fetchStatus: REQUEST_STATUS.IDLE,
            reason: null,
            data: [],
        },
        extensionUrls: [],
    },
};

const reducer = (
    state: SettingsState = initialState,
    action: { type: string; payload?: any } | SettingsActionTypes
): SettingsState => {
    switch (action.type) {
        case RESET_APPLICATION_DETAIL:
            return initialState;

        case GET_APPLICATION_SETTINGS_DATA:
            return {
                ...state,
                isContentLanguageInitialized: false,
                isLoading: true,
                hasError: false,
                data: {
                    id: action.payload,
                },
            };

        case INITIALIZE_CONTENT_LANGUAGE_SUCCESS: {
            return { ...state, isContentLanguageInitialized: true };
        }

        case GET_APPLICATION_SETTINGS_DATA_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasError: false,
                data: {
                    ...state.data,
                    ...clone(action.payload.data),
                },
            };
        case FETCH_LANGUAGE_LIST:
            return {
                ...state,
                languageList: {
                    ...state.languageList,
                    isLoading: true,
                    hasError: false,
                },
            };

        case FETCH_LANGUAGE_LIST_SUCCESS:
            return {
                ...state,
                languageList: {
                    ...state.languageList,
                    data: action.payload,
                    isLoading: false,
                    hasError: false,
                },
            };

        case FETCH_LANGUAGE_LIST_ERROR:
            return {
                ...state,
                languageList: {
                    ...state.languageList,
                    isLoading: false,
                    hasError: true,
                },
            };

        case FETCH_USERS_ACCESS:
            return {
                ...state,
                usersAccess: {
                    ...state.usersAccess,
                    hasError: false,
                    isLoading: true,
                },
            };
        case FETCH_USERS_ACCESS_ERROR:
            return {
                ...state,
                usersAccess: {
                    ...state.usersAccess,
                    hasError: true,
                    isLoading: false,
                },
            };
        case FETCH_USERS_ACCESS_SUCCESS:
            return {
                ...state,
                usersAccess: {
                    ...state.usersAccess,
                    hasError: false,
                    isLoading: false,
                    data: action.payload,
                },
            };

        case FETCH_AVAILABLE_LIST_ADDONS_REQUEST:
            return {
                ...state,
                addonsAvailable: {
                    ...state.addonsAvailable,
                    fetchStatus: REQUEST_STATUS.PENDING,
                    reason: null,
                },
            };

        case FETCH_AVAILABLE_LIST_ADDONS_FAIL:
            return {
                ...state,
                addonsAvailable: {
                    ...state.addonsAvailable,
                    fetchStatus: REQUEST_STATUS.FAILED,
                    reason: action.payload,
                },
            };

        case FETCH_AVAILABLE_LIST_ADDONS_SUCCESS:
            return {
                ...state,
                addonsAvailable: {
                    ...state.addonsAvailable,
                    data: action.payload,
                    fetchStatus: REQUEST_STATUS.SUCCESS,
                },
            };

        case FETCH_AVAILABLE_LIST_ADDONS_IDLE:
            return {
                ...state,
                addonsAvailable: {
                    ...state.addonsAvailable,
                    fetchStatus: REQUEST_STATUS.IDLE,
                    reason: null,
                },
            };

        case FETCH_INSTALLED_LIST_ADDONS_REQUEST:
            return {
                ...state,
                addonsInstalled: {
                    ...state.addonsInstalled,
                    fetchStatus: REQUEST_STATUS.PENDING,
                    reason: null,
                },
            };

        case FETCH_INSTALLED_LIST_ADDONS_FAIL:
            return {
                ...state,
                addonsInstalled: {
                    ...state.addonsInstalled,
                    fetchStatus: REQUEST_STATUS.FAILED,
                    reason: action.payload,
                },
            };

        case FETCH_INSTALLED_LIST_ADDONS_SUCCESS:
            return {
                ...state,
                addonsInstalled: {
                    ...state.addonsInstalled,
                    data: action.payload,
                    fetchStatus: REQUEST_STATUS.SUCCESS,
                },
            };

        case FETCH_INSTALLED_LIST_ADDONS_IDLE:
            return {
                ...state,
                addonsInstalled: {
                    ...state.addonsInstalled,
                    fetchStatus: REQUEST_STATUS.IDLE,
                    reason: null,
                },
            };

        case DELETE_ADDON_SUCCESS:
            return {
                ...state,
                addonsInstalled: {
                    ...state.addonsInstalled,
                    data: state.addonsInstalled.data.filter((addOn) => addOn.id !== action.payload),
                },
            };

        case LOAD_ARTICLES_PICKER_SCRIPT_SUCCESS:
            return {
                ...state,
                addonsScripts: {
                    'google-drive': action.payload,
                },
            };

        case ADD_ON_OAUTH_AUTHORIZATION_CODE_URL_SUCCESS:
            return {
                ...state,
                addonsInstalled: {
                    ...state.addonsInstalled,
                    // TODO https://applearn.atlassian.net/browse/AD-2945
                    data: state.addonsInstalled.data.map((addon: Record<string, any>) =>
                        addon.system_key === action.payload.addonInstanceSystemKey
                            ? {
                                  ...addon,
                                  configuration: {
                                      ...addon.configuration,
                                      authentication: {
                                          ...addon.configuration.authentication,
                                          payload: {
                                              ...addon.configuration.authentication.payload,
                                              authorizationCodeUrl: action.payload.url,
                                              redirectUri: action.payload.redirectUri,
                                          },
                                      },
                                  },
                              }
                            : addon
                    ),
                },
            };
        case OPEN_ADDON_DETAIL_DRAWER:
            return {
                ...state,
                addons: {
                    ...state.addons,
                    selected: action.payload,
                },
            };
        case CLOSE_ADDON_DETAIL_DRAWER:
            return {
                ...state,
                addons: {
                    ...state.addons,
                    selected: null,
                },
            };
        case UPDATE_APPLICATION_ACCESS_REQUEST:
        case UPDATE_APPLICATION_IDENTITY_REQUEST:
        case UPDATE_APPLICATION_THEME_REQUEST:
        case UPDATE_APPLICATION_TRUSTED_DOMAINS_REQUEST:
        case UPDATE_APPLICATION_EXTENSION_URLS_REQUEST:
            return {
                ...state,
                updateStatus: REQUEST_STATUS.PENDING,
            };
        case UPDATE_APPLICATION_ACCESS_SUCCESS:
            return {
                ...state,
                updateStatus: REQUEST_STATUS.SUCCESS,
                data: {
                    ...state.data,
                    access: action.payload.access,
                },
            };
        case UPDATE_APPLICATION_IDENTITY_SUCCESS:
            return {
                ...state,
                updateStatus: REQUEST_STATUS.SUCCESS,
                data: {
                    ...state.data,
                    identity: action.payload.identity,
                },
            };
        case UPDATE_APPLICATION_THEME_SUCCESS:
            return {
                ...state,
                updateStatus: REQUEST_STATUS.SUCCESS,
                data: {
                    ...state.data,
                    theme: action.payload.theme,
                },
            };
        case UPDATE_APPLICATION_EXTENSION_URLS_SUCCESS:
            return {
                ...state,
                updateStatus: REQUEST_STATUS.SUCCESS,
                data: {
                    ...state.data,
                    originUrls: action.payload.extensionUrls.map(eu => eu.url),
                },
            };
        case UPDATE_APPLICATION_TRUSTED_DOMAINS_SUCCESS:
            return {
                ...state,
                updateStatus: REQUEST_STATUS.SUCCESS,
                data: {
                    ...state.data,
                    trustedDomains: action.payload.trustedDomains,
                },
            };
        case UPDATE_APPLICATION_ACCESS_FAIL:
        case UPDATE_APPLICATION_IDENTITY_FAIL:
        case UPDATE_APPLICATION_THEME_FAIL:
        case UPDATE_APPLICATION_EXTENSION_URLS_FAIL:
        case UPDATE_APPLICATION_TRUSTED_DOMAINS_FAIL:
            return {
                ...state,
                updateStatus: REQUEST_STATUS.FAILED,
            };
        case UPDATE_APPLICATION_ACCESS_IDLE:
        case UPDATE_APPLICATION_IDENTITY_IDLE:
        case UPDATE_APPLICATION_THEME_IDLE:
            return {
                ...state,
                updateStatus: REQUEST_STATUS.IDLE,
            };
        case ROLLOUT_POLICIES_BY_MY_ORGANIZATIONS_REQUEST:
            return {
                ...state,
                rolloutPolicies: {
                    ...state.rolloutPolicies,
                    availableRolloutPolicies: {
                        ...state.rolloutPolicies.availableRolloutPolicies,
                        fetchStatus: REQUEST_STATUS.PENDING,
                    },
                },
            };
        case ROLLOUT_POLICIES_BY_MY_ORGANIZATIONS_SUCCESS: {
            const currentOrgId = state.data.organizationId;
            const availableRolloutPolicies = action.payload.filter(
                (rp) => rp.organizationId === currentOrgId
            );

            return {
                ...state,
                rolloutPolicies: {
                    ...state.rolloutPolicies,
                    availableRolloutPolicies: {
                        ...state.rolloutPolicies.availableRolloutPolicies,
                        fetchStatus: REQUEST_STATUS.SUCCESS,
                        data: availableRolloutPolicies,
                    },
                },
            };
        }
        case ROLLOUT_POLICIES_BY_MY_ORGANIZATIONS_ERROR:
            return {
                ...state,
                rolloutPolicies: {
                    ...state.rolloutPolicies,
                    availableRolloutPolicies: {
                        ...state.rolloutPolicies.availableRolloutPolicies,
                        fetchStatus: REQUEST_STATUS.FAILED,
                        reason: action.payload,
                    },
                },
            };
        case ROLLOUT_POLICIES_BY_SPACE_ID_REQUEST:
            return {
                ...state,
                rolloutPolicies: {
                    ...state.rolloutPolicies,
                    rolloutPoliciesBySpace: {
                        ...state.rolloutPolicies.rolloutPoliciesBySpace,
                        fetchStatus: REQUEST_STATUS.PENDING,
                    },
                },
            };
        case ROLLOUT_POLICIES_BY_SPACE_ID_SUCCESS: {
            const extensionUrls = (state.data.originUrls as string[]).map((url) => ({
                url,
                rolloutPolicyId: action.payload.find((obj) => obj.urlPattern === url)?.id,
            }));

            return {
                ...state,
                rolloutPolicies: {
                    ...state.rolloutPolicies,
                    rolloutPoliciesBySpace: {
                        ...state.rolloutPolicies.rolloutPoliciesBySpace,
                        fetchStatus: REQUEST_STATUS.SUCCESS,
                        data: action.payload,
                    },
                    extensionUrls,
                },
            };
        }
        case ROLLOUT_POLICIES_BY_SPACE_ID_ERROR:
            return {
                ...state,
                rolloutPolicies: {
                    ...state.rolloutPolicies,
                    rolloutPoliciesBySpace: {
                        ...state.rolloutPolicies.rolloutPoliciesBySpace,
                        fetchStatus: REQUEST_STATUS.FAILED,
                        reason: action.payload,
                    },
                },
            };
        default:
            return state;
    }
};

export default reducer;
